import { rfqMyQuotesFilterStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { css } from "styled-components";

rfqMyQuotesFilterStyles.clearFiltersButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

rfqMyQuotesFilterStyles.customerDynamicDropdown = {
    cssOverrides: {
        list: css`
            background: #ffffff;
        `,
    },
};
